
























































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import loader from "@/components/loader.vue";

import { momentTZ as moment } from "@/helpers/moment";
import billingApi from "@/services/billing";
import { debounce, cancel } from "typescript-debounce-decorator";
import { Action, Getter, Mutation } from "vuex-class";

import { NSLog } from "@/helpers/log";
import { Coupon } from "@/models/coupon";
import { View } from "../models/view";
const log = NSLog("view/ManageCoupons");

@Component({
  components: {
    loader
  }
})
export default class EditCouponDialog extends Vue {
  get allPublicViews() {
    return this.allViews.filter((v: any) => {
      if (!v.definition) {
        return false;
      }
      return this.showHidden || v.definition.Public;
    });
  }
  @Prop({ required: true }) public value: any;

  @Getter("views") public allViews: any;

  @Action("nav/gotoView") public gotoView: any;
  @Action("nav/deleteView") public deleteViewAction: any;
  private loading = false;
  @Getter("auth/hasPermission") private hasPermission: any;

  private showHidden: boolean = false;

  public async deleteView(view: View) {
    this.loading = true;
    await this.deleteViewAction(view);
    this.loading = false;
  }
}
